import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IDetailsControl } from '../../../shared/models/details-control';
import { IFooterButtonOptions } from 'fas-services';
import { MOCK_DATA } from '../../../shared/helpers/mocked-data';
import { IOskVm } from '../../../../api/osk-vm.model';
import { OskService } from '../../../../api/api-services/osk.service';
import { IOskDetailsVm } from '../../../../api/osk-details-vm.model';
import { IMyOskSubscriptionsVm } from '../../../../api/my-osk-subscriptions-vm.model';
import { IOskOrderPackVm } from '../../../../api/osk-order-pack-vm.model';
import { IOskDetailsUm } from '../../../../api/osk-details-um.model';

@Component({
  selector: 'app-osk-details',
  templateUrl: './osk-details.component.html',
  styleUrl: './osk-details.component.scss',
})
export class OskDetailsComponent {
  @Input() ID_dialog!: string;
  @Input() dataIndex!: number;
  @Input() dataList!: IOskVm[];
  @Input() data!: IOskVm;
  /** Emitted after a successful save so the list can reload the edited row. */
  @Output() oskUpdated = new EventEmitter<void>();

  private dialogStateSubscription!: Subscription;

  private _oskDetailsService = inject(OskService);
  private _dialogService = inject(DialogService);
  private _messageService = inject(MessageService);
  private _fb = inject(FormBuilder);

  public oskForm!: FormGroup;

  public oskDetails!: IOskDetailsVm;
  public dialogState!: IDetailsControl;

  public selectedTabIndex: number = 0;
  
  public oskSubscriptions!: IMyOskSubscriptionsVm[]
  public subscriptionsSelected: IMyOskSubscriptionsVm[] = [];
  public subscriptionsIndex!: number;
  public subscriptions!: IMyOskSubscriptionsVm;

  
  public oskOrderPacks!: IOskOrderPackVm[]
  public transactionSelected: IOskOrderPackVm[] = [];
  public transactionIndex!: number;
  public transaction!: IOskOrderPackVm;


  public oskSubscriptionColumns = [
    {
      field: 'planName',
      header: 'Nazwa',
      contentClass: 'text-sm w-max border-round-sm flex gap-1 py-1 px-2',
      styleColorFunction: this.getFgColor.bind(this),
      styleBackgroundFunction: this.getBgColor.bind(this)
    },
    {
      field: 'availablePlans',
      header: 'Ilość',
      contentClass: 'text-sm',
    },
    {
      field: 'actions',
      header: 'Akcje',
      columnClass: '',
      actions: [
        // {
        //   label: '',
        //   tooltip: 'Usuń',
        //   buttonClass:
        //     'pi pi-trash cursor-pointer text-center appear transparent-button',
        // },
        // {
        //   label: '',
        //   tooltip: 'Przydziel abonament',
        //   buttonClass:
        //     'pi pi-plus cursor-pointer text-center appear transparent-button',
        // },
      ],
    },
  ];

  public oskOrderPackColumns = [
    {
      field: 'created',
      header: 'Data zamówienia',
      contentClass: 'text-sm',
      dateField: true,
    },
    {
      field: 'finishedDate',
      header: 'Data realizacji',
      contentClass: 'text-sm',
      dateField: true,
    },
    {
      field: 'amount',
      header: 'Wartość netto',
      contentClass: 'text-sm',
      valueFunction: (rowData: IOskOrderPackVm) =>
        `${(rowData.amount ?? 0).toFixed(2).replace('.', ',')} zł`,
    },
    {
      // Flaga zamknięcia zamówienia - pakiety zostały przydzielone do OSK (nie ma to nic wspólnego z fakturą).
      field: 'isFinished',
      header: 'Zrealizowane',
      contentClass: 'text-sm',
      booleanField: true,
    },
    {
      field: 'actions',
      header: 'Akcje',
      columnClass: '',
      actions: [
        // {
        //   label: '',
        //   tooltip: 'Usuń',
        //   buttonClass:
        //     'pi pi-trash cursor-pointer text-center appear transparent-button',
        // },
        // {
        //   label: '',
        //   tooltip: 'Przydziel abonament',
        //   buttonClass:
        //     'pi pi-plus cursor-pointer text-center appear transparent-button',
        // },
      ],
    },
  ];

  ngOnInit(): void {
    this.setFormStructure();
    this.dialogStateSubscription = this._dialogService
    .getDialogState(this.ID_dialog)
    .subscribe((state) => {
        this.dialogState = state;
    });
    
    this.loadOskDetails();

  }

  ngOnDestroy(): void {
    this.dialogStateSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      if (changes['data']) {
        this.loadOskDetails();
      }
    }
  }

  getFgColor(data: IMyOskSubscriptionsVm) {
    return data.fgColor
  }

  getBgColor(data: IMyOskSubscriptionsVm) {
    return data.bgColor
  }
  
  private loadOskDetails(): void {
    if (!this.data || !this.data.guid) {
      return;
    }
    this._oskDetailsService.get(this.data.guid).subscribe({
      next: (res: IOskDetailsVm) => {
        this.oskDetails = res;
        if (res.oskSubscriptions) {
          this.oskSubscriptions = res.oskSubscriptions;
        }
        if (res.orderPacks) {
          this.oskOrderPacks = res.orderPacks;
        }
        this.setDefaultValues()
      },
      error: (err) => {
        console.error("Błąd pobierania szczegółów OSK:", err);
      }
    });
  }
  
  setFormStructure(): void {
    this.oskForm = this._fb.group({
      oskShortCode: ['', Validators.required],
      oskUrl: [''],
      oskPhone: ['',],
      oskEmail: ['', Validators.email],
      oskCountry: [''],
      oskPostalCode: [''],
      // The API calls this field OskName - it is the full name of the school.
      companyName: ['', Validators.required],
      oskCity: [''],
      oskStreet: [''],
      nip: ['',],
      lastName: ['',],
      firstName: ['', ],
      email: [{ value: '', disabled: true }]
    });
  }
  

  setDefaultValues(): void {
    if (!this.oskDetails) return;
  
    this.oskForm.patchValue({
      oskShortCode: this.oskDetails.oskShortCode || '',
      oskUrl: this.oskDetails.oskUrl || '',
      oskPhone: this.oskDetails.oskPhone || '',
      oskEmail: this.oskDetails.oskEmail || '',
      oskCountry: this.oskDetails.oskCountry || '',
      oskPostalCode: this.oskDetails.oskPostalCode || '',
      companyName: this.oskDetails.companyName || '',
      oskCity: this.oskDetails.oskCity || '',
      oskStreet: this.oskDetails.oskStreet || '',
      nip: this.oskDetails.nip || '',
      lastName: this.oskDetails.lastName || '',
      firstName: this.oskDetails.firstName || '',
      email: this.oskDetails.email || ''
    });
  }

  updateOskDetails(): void {
    if (this.oskForm.invalid) {
      this.oskForm.markAllAsTouched();
      this._messageService.add({
        severity: 'warn',
        summary: 'Uzupełnij dane',
        detail:
          'Pełna nazwa OSK i skrócona nazwa są wymagane, a adres e-mail musi być poprawny.',
      });
      return;
    }

    const value = this.oskForm.getRawValue();
    // The update model is built explicitly: the details response also carries subscriptions and
    // transactions, and sending them back made the API reject the whole request.
    const payload: IOskDetailsUm = {
      guid: this.oskDetails?.guid || this.data.guid,
      oskName: value.companyName ?? '',
      oskShortCode: value.oskShortCode ?? '',
      oskUrl: value.oskUrl ?? '',
      oskPhone: value.oskPhone ?? '',
      oskEmail: value.oskEmail ?? '',
      oskCountry: value.oskCountry ?? '',
      oskPostalCode: value.oskPostalCode ?? '',
      oskCity: value.oskCity ?? '',
      oskStreet: value.oskStreet ?? '',
      nip: value.nip ?? '',
      firstName: value.firstName ?? '',
      lastName: value.lastName ?? '',
      email: value.email ?? '',
    };

    this._oskDetailsService.put(payload).subscribe({
      next: () => {
        // The card is re-read instead of trusting the response body, so the form always shows
        // what is really stored - no manual refresh needed after saving.
        this.loadOskDetails();
        this.data = { ...this.data, oskName: payload.oskName };
        this.setEditMode(this.ID_dialog, false);
        this.oskUpdated.emit();
        this._messageService.add({
          severity: 'success',
          summary: 'Sukces',
          detail: 'Dane OSK zostały zapisane.',
        });
      },
      error: (err) => {
        console.error('Błąd podczas aktualizacji:', err);
        this._messageService.add({
          severity: 'error',
          summary: 'Błąd',
          detail:
            err?.error?.message ??
            'Nie udało się zapisać danych OSK. Spróbuj ponownie później.',
        });
      }
    });
  }

  editOn() {
    this.setEditMode(this.ID_dialog, true);
  }

  closeDialog(): void {
    this._dialogService.closeDialog(this.ID_dialog);
  }

  openDialog(id: string): void {
    this._dialogService.openDialog(id);
  }

  setEditMode(id: string, isEditing: boolean): void {
    this._dialogService.setEditingState(id, isEditing);
  }

  moveUp() {
    this.dataIndex = (this.dataIndex + 1) % this.dataList.length;
    this.showOsk(this.dataList[this.dataIndex]);
  }

  moveDown() {
    this.dataIndex =
      (this.dataIndex - 1 + this.dataList.length) % this.dataList.length;
    this.showOsk(this.dataList[this.dataIndex]);
  }

  // Switching rows inside the dialog is not an @Input change, so the details have to be
  // reloaded explicitly - otherwise the form kept showing the previously opened OSK.
  private showOsk(osk: IOskVm): void {
    this.data = osk;
    this.setFormStructure();
    this.setEditMode(this.ID_dialog, false);
    this.loadOskDetails();
  }
}
